import { render, staticRenderFns } from "./TeamMatches.vue?vue&type=template&id=7120146a&scoped=true"
import script from "./TeamMatches.vue?vue&type=script&lang=js"
export * from "./TeamMatches.vue?vue&type=script&lang=js"
import style0 from "./TeamMatches.vue?vue&type=style&index=0&id=7120146a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7120146a",
  null
  
)

export default component.exports